<template>
  <div v-if="request">
    <import-new-posts
      v-if="request.assignee === 'client'"
      :account="account"
    />
    <import-initiated
      v-else-if="request.assignee === 'support'"
      :account="account"
    />
    <q-separator class="q-mt-lg" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account, ReconnectRequest } from '@/social/types';
import ImportNewPosts from '../../post/import/with-account/ImportNewPosts.vue';
import ImportInitiated from '../ImportInitiated.vue';

export default defineComponent({
  components: { ImportInitiated, ImportNewPosts },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    request(): ReconnectRequest|null {
      return this.account.reconnectRequest;
    },
  },
});
</script>
